import MyTasksComponent from "./components/MyTasks";

const MyTask = () => {
  // return <div className="my-tasks-page">My Task</div>;
  return <MyTasksComponent />;
};

export default MyTask;
